import React from 'react';
import { motion } from 'framer-motion';
import { FileText, AlertTriangle, CheckCircle } from 'lucide-react';
const docs = [{
  name: 'Elena Rodriguez',
  doc: 'Medical License',
  expiry: '2026-12-01',
  status: 'Pending'
}, {
  name: 'David Kim',
  doc: 'Background Check',
  expiry: '2025-08-15',
  status: 'Expired'
}, {
  name: 'Marcus Chen',
  doc: 'Waiver Form',
  expiry: '2026-10-20',
  status: 'Verified'
}, {
  name: 'Sarah Jenkins',
  doc: 'Medical License',
  expiry: '2027-01-10',
  status: 'Verified'
}, {
  name: 'Tom Wilson',
  doc: 'Media Credentials',
  expiry: '2026-10-10',
  status: 'Pending'
}];
export function Compliance() {
  return <motion.div initial={{
    opacity: 0,
    y: 10
  }} animate={{
    opacity: 1,
    y: 0
  }} className="space-y-6" data-id="element-375">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-376">
        <div data-id="element-377">
          <h1 className="text-2xl font-display font-bold text-white mb-1" data-id="element-378">
            Compliance Tracker
          </h1>
          <p className="text-[var(--muted)] text-sm" data-id="element-379">
            18 documents pending review or expired.
          </p>
        </div>
        <div className="flex gap-3" data-id="element-380">
          <div className="bg-white/5 border border-white/10 rounded-lg px-4 py-2 flex items-center gap-2" data-id="element-381">
            <AlertTriangle className="w-4 h-4 text-orange-400" data-id="element-382" />
            <span className="text-sm font-medium text-white" data-id="element-383">
              18 Action Required
            </span>
          </div>
        </div>
      </div>

      <div className="bg-[var(--surface)] border border-white/5 rounded-xl overflow-hidden" data-id="element-384">
        <div className="overflow-x-auto" data-id="element-385">
          <table className="w-full text-left text-sm" data-id="element-386">
            <thead className="text-xs text-[var(--muted)] uppercase bg-white/[0.02] border-b border-white/5" data-id="element-387">
              <tr data-id="element-388">
                <th className="px-6 py-3 font-medium" data-id="element-389">Volunteer</th>
                <th className="px-6 py-3 font-medium" data-id="element-390">Document Type</th>
                <th className="px-6 py-3 font-medium" data-id="element-391">Expiry Date</th>
                <th className="px-6 py-3 font-medium" data-id="element-392">Status</th>
                <th className="px-6 py-3 font-medium text-right" data-id="element-393">Action</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-white/5" data-id="element-394">
              {docs.map((doc, i) => <motion.tr key={i} initial={{
              opacity: 0
            }} animate={{
              opacity: 1
            }} transition={{
              delay: i * 0.05
            }} className="hover:bg-white/[0.02] transition-colors" data-id="element-395">
                  <td className="px-6 py-4 font-medium text-white" data-id="element-396">
                    {doc.name}
                  </td>
                  <td className="px-6 py-4" data-id="element-397">
                    <div className="flex items-center gap-2 text-[var(--muted)]" data-id="element-398">
                      <FileText className="w-4 h-4" data-id="element-399" />
                      {doc.doc}
                    </div>
                  </td>
                  <td className="px-6 py-4 text-[var(--muted)]" data-id="element-400">
                    {doc.expiry}
                  </td>
                  <td className="px-6 py-4" data-id="element-401">
                    <span className={`inline-flex items-center gap-1.5 px-2 py-1 rounded-full text-xs font-medium ${doc.status === 'Verified' ? 'bg-[var(--success)]/10 text-[var(--success)]' : doc.status === 'Pending' ? 'bg-orange-400/10 text-orange-400' : 'bg-[var(--danger)]/10 text-[var(--danger)]'}`} data-id="element-402">
                      {doc.status}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-right" data-id="element-403">
                    <button className="text-[var(--accent)] hover:text-white transition-colors text-sm font-medium" data-id="element-404">
                      Review
                    </button>
                  </td>
                </motion.tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </motion.div>;
}